import { render, staticRenderFns } from "./UButtonA.vue?vue&type=template&id=9a550c4c&scoped=true&"
import script from "./UButtonA.vue?vue&type=script&lang=js&"
export * from "./UButtonA.vue?vue&type=script&lang=js&"
import style0 from "./UButtonA.vue?vue&type=style&index=0&id=9a550c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a550c4c",
  null
  
)

export default component.exports